<template>
  <div class="ds-control dsf-sc-table-design dsf-sc-dudaimulubudingchang" :class="getCss" @click="click">
    <img :src="'./static/img/project/tableDesign/budaimulubudingchangbiaoti.jpg'" />
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCBudaimulubudingchang",
  ctrlCaption: "不带目录不定长",
  mixins: [$mixins.control],
  props: {
    // 隐藏代码行
    ycdmh: {
      type: Boolean,
      default: true,
    },
    // 代码行可编辑
    dmhkbj: {
      type: Boolean,
      default: true,
    },
    // 显示左右边界
    xszybj: {
      type: Boolean,
      default: true,
    },
    // 隐藏上边界线头
    ycsbjxt: {
      type: Boolean,
      default: true,
    },
    // 隐藏下边界线
    ycxbjx: {
      type: Boolean,
      default: true,
    },
    // 上边界线加粗
    sbjxjc: {
      type: Boolean,
      default: true,
    },
    // 下边界线加粗
    xbjxjc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    click() {
      dsf.layer.openDialog()
    },
  },
});
</script>

<style></style>
